module.exports = "/_next/static/images/mak-0d250b63da2ebea97ad92641d9b30f0a.jpg";